import React, { Component, SyntheticEvent, useState } from "react";
import clsx from "clsx";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import ErrorIcon from "@material-ui/icons/Error";
import InfoIcon from "@material-ui/icons/Info";
import CloseIcon from "@material-ui/icons/Close";
// import { amber, green } from "@material-ui/core/colors";
import IconButton from "@material-ui/core/IconButton";
import Snackbar, { SnackbarProps } from "@material-ui/core/Snackbar";
import SnackbarContent from "@material-ui/core/SnackbarContent";
import WarningIcon from "@material-ui/icons/Warning";
import { v4 as uuidv4 } from "uuid";
import { makeStyles, Theme } from "@material-ui/core/styles";
import NotificationsService, { NotificationPayload } from "../../laco-common/services/notifications";
import { WithOptional } from "../../laco-common/helpers/extendedTypes";

const variantIcon = {
	success: CheckCircleIcon,
	warning: WarningIcon,
	error: ErrorIcon,
	info: InfoIcon,
};

const SnackbarStyles = makeStyles((theme: Theme) => ({
	success: {
		backgroundColor: theme.palette.success.main,
	},
	error: {
		backgroundColor: theme.palette.error.main,
	},
	info: {
		backgroundColor: theme.palette.info.main,
	},
	warning: {
		backgroundColor: theme.palette.warning.main,
	},
	warningLight: {
		backgroundColor: "#FFCB50",
		color: "#666666",
	},
	icon: {
		fontSize: 20,
	},
	iconVariant: {
		opacity: 0.9,
		marginRight: theme.spacing(1),
	},
	message: {
		display: "flex",
		alignItems: "top",
	},
}));

export interface AlertProps {
	variant: keyof typeof variantIcon;
	className?: string;
	message?: string;
	onClose?: () => void;
	hideClose?: boolean;
	hideIcon?: boolean;
	addVariantClass?: keyof ReturnType<typeof SnackbarStyles>;
	children?: React.ReactNode;
	elevation?: number; // 0 - none, up to 24
}

export function UISnackbarContent(props: AlertProps) {
	const classes = SnackbarStyles({});
	const { className, message, onClose, variant, addVariantClass, ...other } = props;
	const Icon = variantIcon[variant];
	const uuid = uuidv4();
	return (
		<SnackbarContent
			className={clsx(classes[variant], classes[addVariantClass], className)}
			aria-describedby={"client-snackbar" + uuid}
			elevation={props.elevation || 4}
			message={
				<span id={"client-snackbar" + uuid} className={classes.message}>
					{!props.hideIcon && <Icon className={clsx(classes.icon, classes.iconVariant)} />}
					{message} {props.children}
				</span>
			}
			action={
				props.hideClose
					? undefined
					: [
							<IconButton key="close" aria-label="close" color="inherit" onClick={onClose}>
								<CloseIcon className={classes.icon} />
							</IconButton>,
					  ]
			}
			{...other}
		/>
	);
}

// const snackbarStyles = makeStyles((theme: Theme) => ({
// 	margin: {
// 		margin: theme.spacing(1)
// 	}
// }));

// interface ISnackbarProps extends WithStyles<typeof snackbarStyles> {}

type UISnackbarsState = NotificationPayload & {
	open: boolean;
	autoHideDuration: number;
	children?: React.ReactNode;
};

export class UISnackbars extends Component<WithOptional<SnackbarProps, "open">, UISnackbarsState> {
	// <ISnackbarProps>
	// private classes = useStyles2({});
	// const [open, setOpen] = React.useState(false);
	private notificationsSub;

	state = {
		open: false,
		message: "",
		level: undefined,
		children: undefined,
		autoHideDuration: 6000,
	};

	componentDidMount() {
		// subscribe to notifications service
		this.notificationsSub = NotificationsService.notifications.subscribe((payload: NotificationPayload) => {
			this.setState({
				message: payload.message,
				level: payload.level,
				open: true,
				autoHideDuration: payload.autoHideDuration || 8000,
				children: payload.children,
			});
		});
	}

	componentWillUnmount() {
		this.notificationsSub.unsubscribe();
	}

	setOpen() {
		this.setState({ open: true });
	}

	handleClick() {
		this.setState({ open: !this.state.open });
	}

	handleClose(event?: SyntheticEvent, reason?: string) {
		if (reason === "clickaway") {
			return;
		}
		this.setState({ open: false });
	}

	render() {
		// const { classes } = this.props;

		return (
			<Snackbar
				anchorOrigin={{
					vertical: "bottom",
					horizontal: "left",
				}}
				open={this.state.open}
				autoHideDuration={this.state.autoHideDuration}
				onClose={this.handleClose.bind(this)}
			>
				<UISnackbarContent
					onClose={this.handleClose.bind(this)}
					variant={this.state.level}
					message={this.state.message}
				>
					{this.state.children}
				</UISnackbarContent>
			</Snackbar>
		);
	}
}

// const UISnackbars = withStyles(snackbarStyles)(CustomizedSnackbars);
// export UISnackbars;

export const UIWarningMsg: React.FC<WithOptional<AlertProps, "variant">> = (props) => {
	const [open, setOpen] = useState(true);
	const [animate, setAnimate] = useState(false);

	return (
		open && (
			<UISnackbarContent
				onClose={() => {
					setAnimate(true);
					setTimeout(() => {
						setOpen(false);
					}, 300);
				}}
				variant="warning"
				elevation={0}
				{...props}
				className={clsx("w-100", animate && "animated fadeOut faster", props.className)}
			></UISnackbarContent>
		)
		// <UISnackbars
		// <div className="alert alert-warning" role="alert">
		// 	This is a warning alert—check it out!
		// </div>
		// <span className="text-gray text-sm ml-1 mr-auto my-2 mt-3-mobile animated shake">
		// 	<i className="im im-warning text-warning mr-1" style={{ fontSize: "10px" }}></i>
		// 	{props.msg}
		// </span>
	);
};
